import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import Footer from "@/components/Footer";
import { parsePost, formatDate } from "@/lib/content";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function PostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPost(null);
    setMissing(false);
    fetch(`/content/posts/${slug}.md`)
      .then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.text();
      })
      .then((raw) => setPost(parsePost(raw)))
      .catch(() => setMissing(true));
  }, [slug]);

  usePageMeta(post?.meta?.title, post?.meta?.excerpt);
  const d = post?.meta?.date ? formatDate(post.meta.date) : null;

  return (
    <>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 pb-20 sm:pb-28 min-h-screen">
        <Reveal>
          <Link
            to="/blog"
            data-testid="post-back-link"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 hover:text-amber-400 transition-colors"
          >
            <ArrowLeft size={14} /> Voltar pro blog
          </Link>
        </Reveal>

        {missing && (
          <p data-testid="post-not-found" className="mt-16 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
            Post não encontrado.
          </p>
        )}

        {post && (
          <article data-testid="blog-post-article" className="mt-10">
            <Reveal>
              {d && (
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-400 mb-4">
                  {d.day} {d.month} {d.year}
                </p>
              )}
              <h1 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tighter leading-[0.95]">
                {post.meta.title}
              </h1>
              {post.meta.tags && (
                <div className="mt-5 flex flex-wrap gap-2">
                  {post.meta.tags.split(",").map((t) => (
                    <span key={t} className="font-mono text-[10px] uppercase tracking-[0.2em] border border-[#3F4462] text-zinc-500 px-3 py-1 rounded-full">
                      {t.trim()}
                    </span>
                  ))}
                </div>
              )}
            </Reveal>
            {post.meta.cover && (
              <Reveal delay={0.1} className="mt-10 border border-[#232638] bg-[#10121A] p-2">
                <img src={post.meta.cover} alt={post.meta.title} className="w-full aspect-[16/8] object-cover" />
              </Reveal>
            )}
            <Reveal delay={0.15}>
              <div className="post-content mt-10" dangerouslySetInnerHTML={{ __html: post.html }} />
            </Reveal>
          </article>
        )}
      </div>
      <Footer />
    </>
  );
}
